export class Report {
  constructor (build) {
    this.id = build.id
    this.title = build.title
    this.target = build.target
    this.supplier = build.supplier
    this.service = build.service
    this.product = build.product
    this.portal = build.portal
    this.openRateCost = build.openRateCost
    this.openRate = build.openRate
    this.open = build.open
    this.materials = build.materials
    this.display = build.display
    this.date = build.date
    this.ctrCost = build.ctrCost
    this.ctr = build.ctr
    this.creation = build.creation
    this.cost1K = build.cost1K
    this.cost = build.cost
    this.click = build.click
    this.visual = build.visual
  }
}
